import React from 'react'
import posed from 'react-pose'

import { useOvermind } from '../overmind'

export const Advert = () => {
  const { state } = useOvermind()

  const Root = posed.div({
    closed: { staggerChildren: 200, delayChildren: 200 },
    open: { staggerChildren: 200, delayChildren: 100 },
    initialPose: 'closed'
  })
  const TopLeft = posed.div({
    open: { y: 0, opacity: 1, transition: { duration: 300 } },
    closed: { y: '-100%', opacity: 0 }
  })

  const TopRight = posed.div({
    open: { x: 0, opacity: 1, transition: { duration: 300 } },
    closed: { x: '100%', opacity: 0 }
  })

  const Bottom = posed.div({
    open: { y: 0, opacity: 1, transition: { duration: 400 } },
    closed: { y: '100%', opacity: 0 }
  })

  return (
    <Root
      className="menuContent"
      initialPose="closed"
      pose={state.menu.isVisibleFirstPanel ? 'open' : 'closed'}
    >
      <div className="menuPanelRow">
        <TopLeft
          className="menuPanelBlock menuPanelBlockHalf"
          dangerouslySetInnerHTML={{ __html: state.menu.adverts.TopLeft }}
        />

        <TopRight
          className="menuPanelBlock menuPanelBlockHalf"
          dangerouslySetInnerHTML={{ __html: state.menu.adverts.TopRight }}
        />
      </div>
      <div className="menuPanelRow">
        <Bottom
          className="menuPanelBlock menuPanelBlockFull"
          dangerouslySetInnerHTML={{ __html: state.menu.adverts.Bottom }}
        />
      </div>
      )
    </Root>
  )
}
